module.exports = __webpack_public_path__ + "static/media/photo-08.30339d04.png";